import { z } from "zod";

const configSchema = z.object({
    API_BASE_URL: z.url().refine((val) => val.at(-1) === "/", {
        message: "url should end with the character '/'",
    }),
});

let config: z.infer<typeof configSchema>;
const result = configSchema.safeParse({
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
});

class EnvironmentVariablesError extends Error {
    constructor(error: z.ZodError) {
        const errorMessage = z.prettifyError(error);

        super(`\n\nErrors while validating environment variables:\n\n${errorMessage}`);
    }
}

if (result.success) {
    config = result.data;
} else {
    throw new EnvironmentVariablesError(result.error);
}

export { config };
